import { Model, go } from 'oderon-vue'

export const WifiNetwork = new Model('/wifi/networks')
WifiNetwork.preview = (id) => go.get(`/wifi/networks/${id}/preview`)
WifiNetwork.getUsage = (id) => go.get(`/wifi/networks/${id}/usage`)
WifiNetwork.patch = (id, body) => go.patch(`/wifi/networks/${id}`, body)
WifiNetwork.findTagCloud = (ps) => go.get(`/wifi/networks/tag-cloud`, ps)

export const WifiAssoc = {}
WifiAssoc.findByNetwork = (nid) => go.get(`/wifi/assocs/network/${nid}`)
WifiAssoc.findByVehicle = (vid) => go.get(`/wifi/assocs/vehicle/${vid}`)
WifiAssoc.saveByVehicle = (vid, body) =>
  go.put(`/wifi/assocs/vehicle/${vid}`, body)
WifiAssoc.previewMailbox = (ps) => go.get(`/wifi/assocs/mailbox`, ps)
